import { useTokenBuyoutListener } from 'src/hooks/pixelCanvas';

export const PopupNotifications = () => {
  useTokenBuyoutListener();

  return null;
};
